import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz45 = () => {
    return (
        <div>
              
<NavLink to='/category/Puzzels/Puzzel44'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title"> Gem in Pockets</h1>
    
    <div class="text">
        <p>Vijay Dinanath Chauhan aka “VDC” was travelling from Bangalore to New Delhi along with his friends. VDC was
            wearing a Cargo Jeans with finite number of small pockets. And in his pockets, there were packets of gems,
            not the real ones,actually the Cadbury gems to eat when he reaches Delhi.In each pocket there was “number of
            packets”, that was equal to the “number of pockets”. In each packet there was a “number of gems”; and the
            “number of gems” was equal to the “number of packets”.Unfortunately, when he reaches Delhi and gets down
            from the train, due to huge crowd he lost one of his Cadbury gems packet.</p>
        <p>Shocked by the incident, as he loves the gems most, he decided not to eat the gems that day, and donate all
            of them to the beggars sitting nearby. But when he went to them, they all started rushing towards him to get
            the gems. He being a good human wanted to distribute those gems equally.&nbsp; Find the number of beggars so
            that he can distribute the gems equally?</p>
        <p><em>Note: No. of beggars&gt;1, No. of pockets&gt;1</em></p>
        <div class='containers'>
        <p style={{textAlign:'justify'}}><strong>Solution:</strong> <br /> 6,VDC was silly, he could have eaten the gems any other
            day! Hahaha, Let the number of pockets be N. The number of gems in each packet is equal to the “no. of
            packets”, and the “number of packets” was equal to the “no of pockets”.</p>
        <p style={{textAlign:'justify'}}>There for the total no. of gems = NxNxN –(N) (for the lost packet), i.e. equal to
            N<sup>3</sup>-N. N<sup>3</sup>-N = N(N<sup>2</sup>-1) = N(N+1) (N-1). This last expression is divisible by 6
            in all cases, since a number is divisible by 6 when it is both divisible by 3 and even. And substituting 2,
            3, 4……and so on, the expression yields 6, 24, 60……&nbsp; where all numbers are divisible by 6.</p><br/>
     </div>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
       
    </div>
</article>
        </div>
    )
}

export default Puz45
